<template>
    <div class="bg-white max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
            class="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 px-4 py-12 sm:px-6 sm:py-24 lg:max-w-7xl lg:grid-cols-1 lg:px-8">
            <div class="grid-rows-1">
                <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    {{ t('headings.courses-to-match-your-needs') }}
                </h2>
                <p class="mt-4 text-gray-500">
                    {{ t('headings.courses-to-match-your-needs-description') }}
                </p>

                <dl class="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-4 sm:gap-y-4 lg:gap-x-4">
                    <a :href="`/courses/${course.slug}`" v-for="(course, index) in courses" :key="index" class="border-t border border-teal-700 rounded-3xl p-8">
                        <dt class="font-medium text-teal-700">{{ course.name }}</dt>
                        <dd class="mt-2 text-sm text-gray-500">{{ course.description.substring(0, 70) }}...</dd>
                    </a>
                    <a href="/courses" class="border-t border border-teal-700 rounded-3xl p-4 bg-primary h-fit">
                        <dt class="font-medium text-gray-900">
                            {{ t('headings.see-more') }}
                            <svg class="inline size-4" fill="none" stroke="currentColor" stroke-width="2"
                                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3">
                                </path>
                            </svg>
                        </dt>
                    </a>
                </dl>
            </div>
        </div>
    </div>
</template>

<script setup type="module">
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { getFeaturedProducts } from '@/services/productService';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const courses = ref([]);

const images = [
    {
        alt: 'Noor Alarabia',
        src: 'images/courses/quran.jpg',
    },
    {
        alt: 'Noor Alarabia',
        src: 'images/courses/tafl.jpg',
    },
    {
        alt: 'Noor Alarabia',
        src: 'images/courses/arabic.jpg',
    },
    {
        alt: 'Noor Alarabia',
        src: 'images/courses/islamic.jpg',
    },
];

onMounted(() => {
    getFeaturedProducts().then((response) => {
        courses.value = response.data;
    }).catch((error) => {
        console.error('Error fetching featured courses:', error);
    });
});
</script>
